import styles from "./TypingDots.module.css";

interface TypingDotsProps {
  botSenderName?: string;
}

const TypingDots = ({ botSenderName = "Hjälprobot" }: TypingDotsProps) => {
  return (
    <div 
      className={styles.container}
      role="status"
      aria-live="polite" 
      aria-label={`${botSenderName} skriver`}
    >
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
    </div>
  );
};

export default TypingDots;
